import { convertToRibuan } from "../../../util/Util"

export const ValueNumberType = ({ value, before, after }) => {
  return (
    <h4 className="font-roboto text-[20px] text-[#424242]">
      {`${before ? before : ''}`} {value ? convertToRibuan(value) : '0'} {`${after ? after : ''}`}
    </h4>
  )
}